import styled from 'styled-components'

interface TextProps {
  fontSize?: string
  fontColor?: string
  fontWeight?: string
}

interface GraphProps {
  height?: string
  width?: string
}

interface DetailWrapperProps {
  $direction?: 'row' | 'column'
}

interface TextWrapperProps {
  $align?: 'flex-start' | 'center' | 'flex-end'
}

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: 100%;
  min-height: 0;
  border-radius: 8px;
  box-shadow: 0px 4px 16px 0px #00000029;
  flex: 1 1 auto;
  overflow: hidden;
`

export const Left = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  flex: 1;
  min-width: 0;
`

export const Right = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;
  min-width: 0;
`

export const BodyWrapper = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  padding: 24px;
  background: #ffffff;
  overflow-y: auto;
`

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
`

export const Body = styled.div`
  display: flex;
  gap: 40px;
`

export const DivisionWrapper = styled.div`
  display: flex;
  gap: 16px;
`

export const DetailWrapper = styled.div<DetailWrapperProps>`
  display: flex;
  width: 100%;
  flex-direction: ${(props) => props.$direction || 'row'};
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
`

export const DetailColWrapper = styled.div`
  display: flex;
  width: 100%;
  padding-left: 10px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
`

export const PatternSelectWrapper = styled.div`
  display: flex;
  width: fit-content;
  max-width: 100%;
  padding: 12px;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  border-radius: 4px;
  border: 1px solid var(--gray30, #e6e6e6);
  background: var(--gray10, #fff);
`

export const GraphWrapper = styled.div<GraphProps>`
  display: flex;
  width: ${(props) => (props.width ? props.width : '421px')};
  height: ${(props) => (props.height ? props.height : '100%')};
  padding: 12px;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  flex: 1 0 0;
  border-radius: 4px;
  border: 1px solid var(--gray30, #e6e6e6);
  background: var(--gray10, #fff);
`

export const GraphBody = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  gap: 8px;
  flex: 1 0 0;
  align-self: stretch;
`

export const TextWrapper = styled.div<TextWrapperProps>`
  display: flex;
  flex-direction: column;
  align-items: ${(props) => props.$align || 'flex-start'};
  gap: 4px;
`

export const TextBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
`

export const TextBox2 = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  padding-top: 1px;
`

export const Text = styled.div<TextProps>`
  color: ${(props) => (props.fontColor ? props.fontColor : '#808080')};
  font-family: SUIT;
  font-size: ${(props) => (props.fontSize ? props.fontSize : '11px')};
  font-style: normal;
  font-weight: ${(props) => (props.fontWeight ? props.fontWeight : '600')};
  line-height: normal;
`

export const SeasonFrame = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`

export const SeasonBox = styled.div`
  display: flex;
  padding: 6px 10px;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
  gap: 2px;
  flex: 1 0 0;
  border-radius: 4px;
  background: var(--bluegray10, #f4f5f8);
`

export const SeasonTextBox = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
`

export const MonthChipWrapper = styled.div`
  display: flex;
  gap: 4px;
`

export const MonthChip = styled.div<{ selected: boolean }>`
  display: flex;
  min-width: 32px;
  height: 18px;
  padding: 0 6px;
  border-radius: 99px;
  background: #57c9a7;
  border: 1px solid #0000001a;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: ${({ selected }) =>
    selected ? 'rgba(87, 201, 167, 1)' : 'rgba(87, 201, 167, 0.1)'};
`

export const MonthChipText = styled.div`
  font-family: SUIT;
  font-size: 12px;
  font-weight: 500;
  text-align: left;
  color: #333333;
`

export const AddButton = styled.div`
  display: flex;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid #c2ecdf;
  gap: 4px;
  background: #f4fcfa;
  align-items: center;
  justify-content: center;

  font-family: SUIT;
  font-size: 12px;
  font-weight: 500;
  color: #666666;

  cursor: pointer;
`
